import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { RR_FILTER_TYPE } from '../../../common/enum/filters/filter-type.enum';
import { RRIFilterOutput } from '../../../common/interfaces/filters/filter-output.interface';
import { RRIFilter } from '../../../common/interfaces/filters/filter.interface';
import { RRIInput } from '../../../form-inputs/interfaces/input-settings.interface';

@Component({
  selector: 'rr-text-search-filter',
  templateUrl: './text-search-filter.component.html',
  styleUrls: ['./text-search-filter.component.scss'],
})
export class TextSearchFilterComponent implements OnInit {
  @Input() model: RRIFilter<string, string>;
  @Output() changedFilter: EventEmitter<RRIFilterOutput<string>> =
    new EventEmitter();
  @Output() cleanFilterClicked: EventEmitter<RRIFilter<string, string>> =
    new EventEmitter();

  public textFieldModel: RRIInput<string> = {
    fieldName: 'filter-search-text',
    label: '',
  };
  public customErrorMessagesText = new Map<string, () => string>([
    ['minlength', () => `Minlength = 3`],
  ]);

  constructor() {}

  ngOnInit(): void {
    this.textFieldModel.label = this.model?.settings?.title ?? '';
    this.textFieldModel.placeholder = this.model?.settings?.title ?? '';
    this.textFieldModel.showFieldHasValue =
      this.model?.settings?.showFieldHasValue;
  }

  setDefaultValues() {
    this.cleanFilterClicked.emit(this.model);
    if (
      this.model.filterBy.defaultValue &&
      typeof this.model.filterBy.defaultValue === 'string'
    ) {
      this.changedFilter.emit({
        type: RR_FILTER_TYPE.TEXT_SEARCH,
        filterBy: {
          ...this.model.filterBy,
          value: this.model.filterBy.defaultValue,
        },
      });
    } else if (this.model.filterBy.value !== '') {
      this.changedFilter.emit({
        type: RR_FILTER_TYPE.TEXT_SEARCH,
        filterBy: {
          ...this.model.filterBy,
          value: '',
        },
      });
    }
  }

  changeInputFilter() {
    if (this.model.filterBy.value && this.model.filterBy.value.length < 3) {
      return;
    }
    this.changedFilter.emit({
      type: RR_FILTER_TYPE.TEXT_SEARCH,
      filterBy: {
        ...this.model.filterBy,
        value: this.model.filterBy.value,
      },
    });
  }
}
